import { ThunkAction } from "redux-thunk";
import { RootState } from "../store";
import { AnyAction } from "redux";
import { MessagesService } from "../services/messages";
import {
  setErrorMessage,
  setSuccessMessage,
} from "./actionsCreators/messageActions";
import { REPORT_WAS_SENT } from "../lib/constants";

export const reportAbuse =
  (id: string, req: any): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await MessagesService.reportAbuse(id, req);

      dispatch(setSuccessMessage(REPORT_WAS_SENT));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };
